import React, { useRef, useState } from 'react';
import { Typography, Button, Form, Input } from 'antd';
import FileUpload from '../../utils/FileUpload';
import Axios from 'axios';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import AWS, { awsBucketName, deleteStoredImage } from '../../utils/S3Helper';

const { Title } = Typography;
const { TextArea } = Input;

let arrStoredImages = null;

function UploadProductPage(props) {
    const quillRef = useRef();
    const state = props.location.state;

    const [TitleValue, setTitleValue] = useState(state?.title || '');
    const [DescriptionValue, setDescriptionValue] = useState(state?.description || '');
    const [Images, setImages] = useState(state?.images || []);
    const [YoutubeLink, setYoutubeLink] = useState(state?.YoutubeLink || '');;

    const onTitleChange = (event) => {
        setTitleValue(event?.currentTarget?.value);
    };

    const onYoutubeLinkChange = (event) => {
        setYoutubeLink(event?.currentTarget?.value);
    };

    const onDescriptionChange = (event) => {
        setDescriptionValue(event?.currentTarget?.value);
    };

    const updateImages = (newImages) => {
        setImages(newImages);
    };

    const onSubmit = (event) => {
        event.preventDefault();

        if (!TitleValue) {
            return alert('제목을 입력해주세요!');
        }

        //사용자가 삭제하라고 선택한 이미지들을 담아두자. (수정 요청 성공후 이미지 서버에서 삭제하기 위함)
        const imagesRemoved = state?.images.filter(img => !Images.includes(img));

        //Images 에서 file path 아니고 URL(string) 인 멤버들은 제외
        const imagesNewFile = Images.filter(item => typeof item != "string");

        let arrPromise = imagesNewFile.map(file => {
            return new AWS.S3.ManagedUpload({
                params: {
                    Bucket: awsBucketName,
                    Key: `product/${props.user.userData.email.replaceAll('@', '_')}/product_${Date.now()}`,
                    Body: file,
                    ContentType: file.type,
                },
            }).promise();
        })

        Promise.all(arrPromise).then(arrResponse => {
            arrStoredImages = arrResponse.map(data => data.Location);

            const variables = {
                writer: props.user.userData._id,
                writerData: props.user.userData,
                title: TitleValue,
                description: DescriptionValue,
                YoutubeLink,
            };

            if (arrStoredImages?.length || imagesRemoved?.length) {
                //images = Images(Old) - Images(Removed) + Images(New)
                variables.images = state?.images.filter(img => !imagesRemoved?.includes(img)).concat(arrStoredImages);
            }

            if (state?.isModify) {
                return Axios.put('/api/product/' + state?._id, variables);
            }
            else {
                return Axios.post('/api/product/uploadProduct', variables);
            }

        }).then(response => {
            if (response.data.success) {
                alert(state?.isModify ? '수정되었습니다' : '등록되었습니다');
                deleteStoredImage(props, imagesRemoved);
                props.history.push('/');
            } else {
                alert('등록실패:' + response.data.err);
            }
        }).catch(alert);

    };

    return (
        <div className='page'>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                <Title level={2}> 등록하기 </Title>
            </div>

            <Form onSubmit={onSubmit} >

                {/* DropZone */}
                <FileUpload refreshFunction={updateImages} images={Images} />

                <br /><br />
                <label>제목</label>
                <Input
                    onChange={onTitleChange}
                    value={TitleValue}
                />

                <br /><br />
                <label>Youtube 영상 링크 (선택)</label>
                <Input
                    onChange={onYoutubeLinkChange}
                    value={YoutubeLink}
                />

                <br /><br />
                <label>설명</label>
                <ReactQuill ref={(element) => {
                    if (element !== null) {
                        quillRef.current = element;
                        // console.log(quillRef?.current?.getEditor().getText());
                    }
                }}
                    theme="snow" value={DescriptionValue} onChange={setDescriptionValue}
                    style={{ background: '#fff' }} />

                <br /><br />
                <Button
                    size="large" type="primary"
                    onClick={onSubmit}
                >
                    {state?.isModify ? '수정하기' : '등록하기'}
                </Button>

            </Form>

        </div>
    );
}

export default UploadProductPage;
